import { render, staticRenderFns } from "./QuoteFormPremium.vue?vue&type=template&id=1959f977&scoped=true&"
import script from "./QuoteFormPremium.vue?vue&type=script&lang=ts&"
export * from "./QuoteFormPremium.vue?vue&type=script&lang=ts&"
import style0 from "./QuoteFormPremium.vue?vue&type=style&index=0&id=1959f977&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1959f977",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VForm,VImg})
